import React from "react";
import KeyMetrics from "./KeyMetrics/KeyMetrics";
import ActiveProjects from "./ActiveProjects/ActiveProjects";
import Notifications from "./Notifications/Notifications";

const Dashboard = () => {
    return (
        <div className="Dashboard">
            <div className="metricContainer">
                <div className="metricCard">
                    <KeyMetrics />
                    <ActiveProjects />
                </div>
                <div className="metricCard">
                    <Notifications />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
